import * as XLSX from 'xlsx';
import { Session } from '../types';

function fmtTime(h: number, m: number): string {
  return `${String(h).padStart(2, '0')}h${String(m).padStart(2, '0')}`;
}

export function exportExcel(sessions: Session[]): void {
  const wb = XLSX.utils.book_new();

  const now      = new Date();
  const dateGen  = now.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeGen  = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });

  sessions.forEach((session, si) => {
    const totalVerif = session.resultats.reduce((s, r) => s + r.part, 0);
    const totalPoids = session.parts.reduce((s, p) => s + p.poids, 0);

    // ── Bloc d'en-tête ──
    const meta: (string | number)[][] = [
      ['Répartition N°', si + 1],
    ];
    if (session.zone)       meta.push(['Zone',        session.zone]);
    if (session.controleur) meta.push(['Contrôleur',  session.controleur]);
    meta.push(
      ['Montant total',  session.montant],
      ['Arrondi',        `Multiple de ${session.base}`],
      ['Total vérifié',  totalVerif],
      ['Généré le',      `${dateGen} à ${timeGen}`],
      [],
    );

    // ── En-tête du tableau ──
    const header = ['#', 'Bénéficiaire', 'Plage horaire', 'Poids', 'Montant arrondi', 'Part %'];

    // ── Lignes de données ──
    const dataRows = session.resultats.map(r => [
      r.index + 1,
      r.nom || `Personne ${r.index + 1}`,
      `${fmtTime(r.heureDebut, r.minuteDebut)} - ${fmtTime(r.heureFin, r.minuteFin)}`,
      r.poids,
      r.part,
      parseFloat(r.pourcentage.toFixed(2)),
    ]);

    // ── Ligne TOTAL ──
    const totalRow = ['', 'TOTAL', '', totalPoids, totalVerif, 100];

    const aoa: (string | number)[][] = [
      ...meta,
      header,
      ...dataRows,
      totalRow,
    ];

    const ws = XLSX.utils.aoa_to_sheet(aoa);

    // ── Largeurs de colonnes ──
    ws['!cols'] = [
      { wch: 4  },   // #
      { wch: 22 },   // Bénéficiaire
      { wch: 18 },   // Plage horaire
      { wch: 8  },   // Poids
      { wch: 18 },   // Montant arrondi
      { wch: 10 },   // Part %
    ];

    // Nom de l'onglet : zone ou numéro
    const sheetName = session.zone
      ? session.zone.slice(0, 31).replace(/[:\\/?*[\]]/g, '-')
      : `Répartition ${si + 1}`;

    XLSX.utils.book_append_sheet(wb, ws, sheetName);
  });

  const fileName = `repartition_${new Date().toISOString().slice(0, 10)}.xlsx`;
  XLSX.writeFile(wb, fileName);
}
